const state = {
    companyProfile : {
        address : null,
        created_at : null,
        email : null,
        fax_number : null,
        fullname : null,
        logo : null,
        logo_alternate : null,
        name : null,
        phone_number : null,
        updated_at : null,
        website : null
    },
}

const getters = {
    getCompanyProfile : (state) => {
      return state.companyProfile
    }
}

const mutations = {
    companyProfileStatus (state, companyProfile){
        if(companyProfile){
            this.state.companyProfile = companyProfile;
        } else {
            this.state.companyProfile = {
                address : null,
                created_at : null,
                email : null,
                fax_number : null,
                fullname : null,
                logo : null,
                logo_alternate : null,
                name : null,
                phone_number : null,
                updated_at : null,
                website : null
            };
        }
    },
}

const actions = {
    setCompanyProfile ({ commit }, companyProfile){
        commit('companyProfileStatus', companyProfile);
    }
}

export default{
    state,
    getters,
    mutations,
    actions
}